import { render, staticRenderFns } from "./CustomersOverview.vue?vue&type=template&id=ef9a0c36&scoped=true"
import script from "./CustomersOverview.vue?vue&type=script&lang=js"
export * from "./CustomersOverview.vue?vue&type=script&lang=js"
import style1 from "./CustomersOverview.vue?vue&type=style&index=1&id=ef9a0c36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9a0c36",
  null
  
)

export default component.exports